/**
 * Restock Rocket Button Positioner
 * Move os botões "Avise-me" do app Stoq para baixo dos botões de compra
 * Estiliza os botões para seguir o padrão visual do site
 */

(function() {
  'use strict';

  /**
   * Fixa o modal do Restock Rocket no centro da tela
   * Usa CSS injetado para não interferir com a visibilidade controlada pelo app
   */
  function fixRestockModal() {
    // Verifica se o CSS já foi injetado
    if (document.querySelector('#restock-rocket-fix-styles')) return;
    
    // Injeta CSS para estilizar o modal quando ele aparecer
    const style = document.createElement('style');
    style.id = 'restock-rocket-fix-styles';
    style.textContent = `
      #restock-rocket {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        z-index: 2147483647 !important;
        background-color: rgba(0, 0, 0, 0.5) !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: none !important;
      }
      
      #restock-rocket:empty,
      #restock-rocket[style*="display: none"],
      #restock-rocket[style*="visibility: hidden"] {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * Estiliza o botão do Restock Rocket na PDP para seguir o padrão do site
   */
  function styleRestockButtonPDP() {
    // Seleciona o container do botão na PDP
    const containers = document.querySelectorAll('.restock-rocket-button-container');
    
    containers.forEach(container => {
      // Verifica se já foi estilizado
      if (container.dataset.styled === 'true') return;
      
      const button = container.querySelector('button, a, .restock-rocket-button');
      if (!button) return;
      
      // Aplica estilos inline para sobrescrever os do app
      Object.assign(button.style, {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '48px',
        padding: '12px 24px',
        backgroundColor: '#000',
        color: '#fff',
        border: 'none',
        borderRadius: '0',
        fontSize: '14px',
        fontWeight: '700',
        fontFamily: "'Roboto', sans-serif",
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        textDecoration: 'none',
        boxSizing: 'border-box'
      });
      
      // Hover effect
      button.addEventListener('mouseenter', () => {
        button.style.backgroundColor = '#333';
      });
      
      button.addEventListener('mouseleave', () => {
        button.style.backgroundColor = '#000';
      });
      
      // Estiliza o container também
      Object.assign(container.style, {
        width: '100%',
        marginTop: '8px'
      });
      
      // Marca como estilizado
      container.dataset.styled = 'true';
    });
  }

  function moveRestockButtons() {
    // Seleciona todos os botões do Stoq que estão fora do container correto
    const restockButtons = document.querySelectorAll('.restock-rocket-button.restock-rocket-button-collection');
    
    restockButtons.forEach((button, index) => {
      
      // Verifica se o botão já foi movido (evita duplicação)
      if (button.dataset.moved === 'true') {
        return;
      }
      
      // Encontra o card-wrapper pai
      const cardWrapper = button.closest('.card-wrapper');
      if (!cardWrapper) {
        return;
      }
      
      // Encontra o container .quick-add dentro do card
      const quickAddContainer = cardWrapper.querySelector('.quick-add');
      if (!quickAddContainer) {
        return;
      }
      
      // Verifica se já existe um container para o botão Stoq
      let stoqContainer = quickAddContainer.querySelector('.stoq-notifyme-btn');
      
      if (!stoqContainer) {
        // Cria o container se não existir
        stoqContainer = document.createElement('div');
        stoqContainer.className = 'stoq-notifyme-btn';
        stoqContainer.style.marginTop = '8px';
        quickAddContainer.appendChild(stoqContainer);
      }
      
      // Move o botão para dentro do container correto
      stoqContainer.appendChild(button);
      
      // Marca como movido
      button.dataset.moved = 'true';
    });
  }

  /**
   * Executa todas as funções de posicionamento e estilização
   */
  function processRestockButtons() {
    moveRestockButtons();
    styleRestockButtonPDP();
    fixRestockModal();
  }

  // Executa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processRestockButtons);
  } else {
    processRestockButtons();
  }

  // Executa quando a página terminar de carregar completamente
  window.addEventListener('load', () => {
    setTimeout(processRestockButtons, 100);
  });

  // Observa mudanças no DOM para produtos carregados dinamicamente
  const observer = new MutationObserver((mutations) => {
    let shouldProcess = false;
    
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Detecta botões, containers e modal (por ID)
          if (node.classList && (
            node.classList.contains('restock-rocket-button') || 
            node.classList.contains('restock-rocket-button-container')
          )) {
            shouldProcess = true;
          } else if (node.id === 'restock-rocket') {
            shouldProcess = true;
          } else if (node.querySelector && (
            node.querySelector('.restock-rocket-button') || 
            node.querySelector('.restock-rocket-button-container') ||
            node.querySelector('#restock-rocket')
          )) {
            shouldProcess = true;
          }
        }
      });
    });
    
    if (shouldProcess) {
      // Delay para garantir que o app Stoq terminou de renderizar
      setTimeout(processRestockButtons, 200);
    }
  });

  // Observa o body inteiro para capturar novos botões
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Re-executa periodicamente para garantir que pegue os botões do Stoq
  // O app Stoq pode demorar para carregar, então executamos várias vezes
  const intervals = [500, 1000, 1500, 2000, 3000, 4000, 5000, 7000, 10000];
  intervals.forEach(delay => {
    setTimeout(processRestockButtons, delay);
  });
  
  // Observa especificamente quando scripts externos são carregados
  const scriptObserver = new MutationObserver(() => {
    setTimeout(processRestockButtons, 300);
  });
  
  scriptObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src']
  });
})();
